import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';

@Component({
	selector: 'app-loader',
	styleUrl: './loader-component.scss',
	templateUrl: './loader-component.html',
	imports: [CommonModule, FaIconComponent],
	standalone: true,
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoaderComponent { }
